<template>
  <div class="inspection-task-map-container">
    <div id="inspectionTaskMap" style="width: 100%; height: 600px;"></div>
  </div>
</template>

<script>
import { queryInspectionTaskDetail } from '@/api/inspection/inspectionPointApi'
import { getCommunityId } from '@/api/community/communityApi'
import { listSystemInfo } from '@/api/system/systemInfoManageApi'

export default {
  name: 'InspectionTaskMap',
  data() {
    return {
      map: null,
      communityId: '',
      taskPoints: [],
      amapKey: '',
      markers: [],
      polyline: null
    }
  },
  async mounted() {
    this.communityId = getCommunityId()
    await this.loadAmapKey()
    await this.loadAmapScript()
  },
  methods: {
    async loadAmapKey() {
      try {
        const { data } = await listSystemInfo({ page: 1, row: 1 })
        if (data && data.length > 0 && data[0].qqMapKey) {
          this.amapKey = data[0].qqMapKey
        } else {
          this.amapKey = '2d4592252d5a8e57f8eb1b47aaef0d24'
        }
      } catch (error) {
        console.error('获取地图Key失败:', error)
        this.amapKey = '2d4592252d5a8e57f8eb1b47aaef0d24'
      }
    },

    loadAmapScript() {
      if (window.AMap) {
        return Promise.resolve()
      }

      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = `https://webapi.amap.com/maps?v=2.0&key=${this.amapKey}`
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },

    loadData(task) {
      console.log('loadData', task)
      this.initMap()
      this.loadTask(task)
    },

    initMap() {
      // 清除之前的标记和折线
      if (this.markers && this.markers.length > 0) {
        this.markers.forEach(marker => marker.setMap(null))
        this.markers = []
      }
      if (this.polyline) {
        this.polyline.setMap(null)
        this.polyline = null
      }
      if (this.map) {
        this.map.destroy()
        this.map = null
      }
      console.log('initMap', this.map)

      // 默认中心点（北京）
      const center = [116.397128, 39.916527]
      console.log('center', center)

      // 创建地图实例
      this.map = new window.AMap.Map('inspectionTaskMap', {
        center: center,
        zoom: 13,
        viewMode: '2D'
      })
    },

    async loadTask(task) {
      if (!task || !task.taskId) return

      try {
        const params = {
          communityId: this.communityId,
          taskId: task.taskId,
          page: 1,
          row: 1000
        }

        const response = await queryInspectionTaskDetail(params)
        this.taskPoints = response.data
        this.addPointsToMap(this.taskPoints)
      } catch (error) {
        console.error('获取任务点失败:', error)
        this.$message.error(this.$t('inspectionTaskMap.fetchError'))
      }
    },

    addPointsToMap(points) {
      if (!this.map || !points || points.length === 0) return

      // 清除之前的标记和折线
      if (this.markers && this.markers.length > 0) {
        this.markers.forEach(marker => marker.setMap(null))
        this.markers = []
      }
      if (this.polyline) {
        this.polyline.setMap(null)
        this.polyline = null
      }

      const path = []

      points.forEach(point => {
        if (!point.lat || !point.lng) return

        const position = [point.lng, point.lat]
        path.push(position)

        // 根据状态选择不同的图标和标签颜色
        const isCompleted = point.state === '20200405'
        const icon = isCompleted ? '/img/inspection_do.png' : '/img/inspection.png'
        const labelColor = isCompleted ? '#CC0000' : '#3777FF'

        // 创建标记，带文本标签
        const marker = new window.AMap.Marker({
          position: position,
          map: this.map,
          icon: icon,
          offset: new window.AMap.Pixel(-13, -30),
          label: {
            content: `<div style="color: ${labelColor}; font-size: 14px;">${point.inspectionName}</div>`,
            direction: 'bottom',
            offset: new window.AMap.Pixel(0, 5)
          }
        })

        this.markers.push(marker)
      })

      // 创建路径折线
      if (path.length > 1) {
        this.polyline = new window.AMap.Polyline({
          path: path,
          strokeColor: '#3777FF',
          strokeWeight: 6,
          strokeOpacity: 0.8,
          lineJoin: 'round',
          lineCap: 'round'
        })
        this.polyline.setMap(this.map)
      }

      // 自动调整地图视野以包含所有点
      if (path.length > 0) {
        if (path.length === 1) {
          this.map.setCenter(path[0])
          this.map.setZoom(16)
        } else {
          this.map.setFitView(this.markers)
        }
      }
    }
  },
  beforeDestroy() {
    // 组件销毁时清除地图实例
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  }
}
</script>

<style scoped>
.inspection-task-map-container {
  width: 100%;
  height: 100%;
}
</style>